import * as React from 'react';
import { connect } from 'react-redux';
import * as classnames from 'classnames';
import {
    UilPen,
    UilTrashAlt,
    UilCheckCircle,
    UilVolume
} from '@iconscout/react-unicons';
import { getConfirmationBox } from '../../../../common/swal/Sweetalert';
import { alertMessage } from '../../../../../constants/alertMessage';
import {
    deleteMedia,
    updateMedia
} from '../../../../../services/media.service';
interface MediaItemProps {
    media: any;
    active?: boolean;
    editEnable?: boolean;
    applyCurrentMedia?: () => void;
    deleteMedia: (id) => Promise<void>;
    updateMedia: (id: number, media: any) => Promise<void>;
}

const MediaItem: React.FC<MediaItemProps> = ({
    media,
    active,
    editEnable,
    applyCurrentMedia,
    updateMedia,
    deleteMedia
}: MediaItemProps) => {
    const [editing, setEditing] = React.useState(false);
    const [label, setLabel] = React.useState(media?.label);

    React.useEffect(() => {
        setLabel(media.label);
    }, [media.isUploading]);
    const handleDeleteItem = async (e) => {
        e.stopPropagation();
        const { isConfirmed } = await getConfirmationBox({
            showCloseButton: true,
            showCancelButton: true,
            title: alertMessage.DELETE_ITEM,
            message: alertMessage.MEDIA_DELETE_CONFIRM
        });

        if (isConfirmed) {
            try {
                await deleteMedia(media.mediaId);
            } catch (err) {}
        }
    };

    const handleEditMediaLabel = async (e) => {
        e.stopPropagation();
        if (!editing) {
            setEditing(true);
            return;
        }
        try {
            await updateMedia(media.mediaId, { ...media, label });
        } catch (err) {}
        setEditing(false);
    };
    if (media.isUploading) {
        return (
            <div className="media-item--uploading">
                <span className="media-item--uploading--title">
                    Uploading...
                </span>
                <span className="media-item--uploading--progress">
                    <span
                        className="media-item--uploading--progress-percentage"
                        style={{ width: '5%' }}
                    ></span>
                </span>
            </div>
        );
    }
    const isVideo = media.type === 'video' || media.mediaURL.includes('mp4');
    const editable = editEnable && !media?.global;
    return (
        <div className={classnames('media-item--uploaded', { active })}>
            <span
                className={classnames('media-item--uploaded--image', {
                    active
                })}
                onClick={() => {
                    !active && applyCurrentMedia();
                }}
            >
                {isVideo ? (
                    <video controls={false} autoPlay={false}>
                        <source src={media.mediaURL} type="video/mp4" />
                    </video>
                ) : media.type === 'audio' ? (
                    <UilVolume size={40} color="#2d67cb" />
                ) : (
                    <img src={media.mediaURL} alt={media.label} />
                )}
            </span>
            <div className="media-item--uploaded--footer">
                <input
                    style={{
                        width: editable ? 'calc(100% - 50px)' : '100%'
                    }}
                    type="text"
                    value={label}
                    disabled={!editing}
                    autoFocus
                    onChange={(e) => {
                        e.stopPropagation();
                        setLabel(e.target.value);
                    }}
                />
                {editable && (
                    <div>
                        {editing ? (
                            <span
                                className="media-item--uploaded--edit confirm"
                                onClick={handleEditMediaLabel}
                            >
                                <UilCheckCircle size={20} />
                            </span>
                        ) : (
                            <>
                                <span
                                    className="media-item--uploaded--edit"
                                    onClick={handleEditMediaLabel}
                                >
                                    <UilPen size={20} />
                                </span>
                                <span
                                    className="media-item--uploaded--delete"
                                    onClick={handleDeleteItem}
                                >
                                    <UilTrashAlt size={20} />
                                </span>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
    deleteMedia: (id: number) => dispatch(deleteMedia(id)),
    updateMedia: (id: number, media: any) => dispatch(updateMedia(id, media))
});

export default connect(mapStateToProps, mapDispatchToProps)(MediaItem);
